export default "__VITE_ASSET__BgzAzqcI__"